/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-unresolved */
import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Image } from 'react-bootstrap'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/autoplay'
import { Autoplay } from 'swiper/modules'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBars,
  faVolumeXmark,
  faVolumeHigh,
} from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function CarouselFilmPreview({
  srcs,
  correspondVideos,
  showIntro = false,
  redirectUrl,
}) {
  const swiperRef = useRef(null)
  const videoRefs = useRef([])
  const [isMuted, setIsMuted] = useState(true)
  const [showMainSwiper, setShowMainSwiper] = useState(!showIntro)
  const [showIntroSwiper, setShowIntroSwiper] = React.useState(showIntro)
  const validImages = srcs.filter(
    (src) =>
      src.file instanceof Blob ||
      src.file instanceof File ||
      (typeof src.file === 'string' && src.file.startsWith('blob:'))
  )

  return (
    <div className="scroller-hide">
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
      </div>
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <br />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <br />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />

      {showIntroSwiper && (
        <Swiper
          slidesPerView={1.5}
          centeredSlides
          loop
          spaceBetween={20}
          allowTouchMove={false}
          autoplay={{
            delay: 400,
            disableOnInteraction: true,
          }}
          modules={[Autoplay]}
          onSlideChange={(swiper) => {
            if (swiper.realIndex === validImages.length - 1) {
              setTimeout(() => {
                setShowIntroSwiper(false)
                setShowMainSwiper(true)
              }, 500)
            }
          }}
          style={{
            width: '240px',
            margin: '0 auto',
            bottom: '8%',
            position: 'absolute',
            zIndex: 10,
          }}
        >
          {validImages.map((img, i) => {
            const videoFile = correspondVideos?.[i]?.file
            let videoURL = null
            if (videoFile instanceof File || videoFile instanceof Blob) {
              videoURL = URL.createObjectURL(videoFile)
            } else if (typeof videoFile === 'string') {
              videoURL = videoFile
            }

            return (
              <SwiperSlide key={`intro-${i}`} style={{ position: 'relative' }}>
                {videoURL && (
                  <video
                    src={videoURL}
                    autoPlay
                    muted
                    loop
                    playsInline
                    style={{
                      position: 'absolute',
                      left: 0,
                      top: 0,
                      width: '75%',
                      height: '100%',
                      objectFit: 'cover',
                      zIndex: 2,
                    }}
                  />
                )}
                <img
                  src={
                    typeof img.file === 'string'
                      ? img.file
                      : URL.createObjectURL(img.file)
                  }
                  alt={`Slide ${i + 1}`}
                  style={{
                    width: '100%',
                    objectFit: 'cover',
                    display: 'block',
                  }}
                />
                <CIIcon />
              </SwiperSlide>
            )
          })}
        </Swiper>
      )}

      {showMainSwiper && (
        <>
          <button
            type="button"
            onClick={() => setShowMainSwiper(false)}
            style={{
              position: 'absolute',
              bottom: '27%',
              right: '19.5%',
              zIndex: 20,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              border: 'none',
              color: 'white',
              fontSize: '18px',
              height: '25px',
              width: '25px',
              padding: '0rem 0.5rem 0.5rem 0.5rem',
              display: 'flex',
              borderRadius: '50%',
              cursor: 'pointer',
            }}
          >
            ✕
          </button>
          <Swiper
            ref={swiperRef}
            slidesPerView={1}
            centeredSlides
            loop
            grabCursor
            speed={600}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            modules={[Autoplay]}
            style={{
              width: '240px',
              margin: '0 auto',
              bottom: '8%',
              position: 'absolute',
            }}
          >
            {validImages.map((img, i) => {
              const videoFile = correspondVideos?.[i]?.file
              let videoURL = null
              if (videoFile instanceof File || videoFile instanceof Blob) {
                videoURL = URL.createObjectURL(videoFile)
              } else if (typeof videoFile === 'string') {
                videoURL = videoFile
              }

              return (
                <SwiperSlide
                  key={i}
                  style={{ position: 'relative' }}
                  onClick={() => {
                    if (redirectUrl) window.open(redirectUrl, '_blank')
                  }}
                >
                  {videoURL && (
                    <>
                      <video
                        ref={(el) => {
                          videoRefs.current[i] = el
                        }}
                        muted={isMuted}
                        src={videoURL}
                        autoPlay
                        loop
                        playsInline
                        style={{
                          position: 'absolute',
                          left: 0,
                          top: 0,
                          width: '75%',
                          height: '100%',
                          objectFit: 'cover',
                          zIndex: 2,
                        }}
                      >
                        <track kind="captions" srcLang="en" src="" default />
                      </video>
                      <div
                        role="presentation"
                        onClick={(e) => {
                          e.stopPropagation()
                          const newMuted = !isMuted
                          setIsMuted(newMuted)
                          videoRefs.current.forEach((videoEl) => {
                            const el = videoEl
                            if (el) el.muted = newMuted
                          })
                        }}
                        style={{
                          position: 'absolute',
                          left: '5px',
                          bottom: '5px',
                          zIndex: 1100,
                          backgroundColor: 'rgba(0,0,0,0.5)',
                          borderRadius: '50%',
                          width: '32px',
                          height: '32px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          cursor: 'pointer',
                        }}
                      >
                        <FontAwesomeIcon
                          icon={isMuted ? faVolumeXmark : faVolumeHigh}
                          style={{ color: 'white', fontSize: '18px' }}
                        />
                      </div>
                    </>
                  )}
                  <img
                    src={
                      typeof img.file === 'string'
                        ? img.file
                        : URL.createObjectURL(img.file)
                    }
                    alt={`Slide ${i + 1}`}
                    style={{
                      width: '100%',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                  <CIIcon />
                </SwiperSlide>
              )
            })}
          </Swiper>
        </>
      )}
    </div>
  )
}

CarouselFilmPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ).isRequired,

  correspondVideos: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      preview: PropTypes.string,
      type: PropTypes.string,
    })
  ),
  showIntro: PropTypes.bool,
  redirectUrl: PropTypes.string,
}

CarouselFilmPreview.defaultProps = {
  showIntro: false,
  redirectUrl: '',
}

export default CarouselFilmPreview
